import { businessApi } from '../../api';
import { BusinessConfigurationForm } from '../../types/business/BusinessTypes';

const BusinessConfigService = {
  /**
   * Obtiene la configuración actual de la empresa.
   * GET /api/business-configuration
   */
  getConfiguration: async () => {
    const response = await businessApi.fetchAll();
    return response.data;
  },

  /**
 * Crea la configuración de la empresa.
 * POST /api/business-configuration
 * Envía FormData con los datos y hasta 2 archivos opcionales.
 */
  createConfiguration: async (
    data: BusinessConfigurationForm,
    file?: File,      // archivo principal
    file2?: File      // segundo archivo opcional
  ) => {
    const response = await businessApi.postFormData(data, file, file2);
    return response.data;
  },

  /**
   * Actualiza la configuración de la empresa.
   * PUT /api/business-configuration/{id}
   * Envía FormData con los datos y hasta 2 archivos opcionales.
   */
  updateConfiguration: async (
    id: number,
    data: BusinessConfigurationForm,
    file?: File,      // archivo principal
    file2?: File      // segundo archivo opcional
  ) => {
    const response = await businessApi.putFormData(id, data, file, file2);
    return response.data;
  },



  /**
 * Recupera la imagen del logo de empresa como Blob y retorna su URL.
 */
  getBusinessLogoUrl: async (filename: string): Promise<string | null> => {
    try {
      const response = await businessApi.fetchBlob(`/logo/${filename}`);

      // Crear un Blob URL a partir de la respuesta
      const imageUrl = URL.createObjectURL(response.data);
      return imageUrl;
    } catch (error) {
      console.error("Error obteniendo el logo de la empresa:", error);
      return null;
    }
  },

};

export default BusinessConfigService;
